import React from 'react'
import {
  ColumnLayout,
  Container,
  FormField,
  Header,
  Input,
  SpaceBetween,
  Tiles
} from "@amzn/awsui-components-react-v3";
import { Controller } from "react-hook-form";

export default function MiscInfo(props: any) {
  return (
    <Container
      header={
        <Header
          variant="h2"
          description="Name and website of the application and vendor"
        >
          3P application information
        </Header>
      }
    >
      <SpaceBetween size="l">
        <ColumnLayout columns={2}>
          <FormField
            stretch={true}
            label="Name of 3P Application/Platform/Service" errorText={props.errors?.app_name?.message?.toString()}
            description="This should be the name of the 3P SaaS/PaaS that you or your team is using"
          >
            <Controller
              name="app_name"
              defaultValue={""}
              rules={{
                required: "Required field",
                maxLength: {
                  value: 64,
                  message: "Maximum accepted length is 64"
                },
                pattern: {
                  value: /^[\w\-\s]+$/,
                  message: "Only alphanumeric accepted"
                }
              }}
              control={props.control}
              render={({ field: { onBlur, onChange, value } }) => (
                <Input placeholder="Quip" value={value} onChange={({ detail }) => {
                  onChange(detail.value);
                }}
                  onBlur={onBlur} />
              )} />
          </FormField>
          <FormField
            stretch={true}
            description="Enter the full URL of the application/platform/service"
            label="Application/Platform/Service website" errorText={props.errors?.product_url?.message?.toString()}>
            <Controller
              name="product_url"
              rules={{
                required: "Required field",
                pattern: {
                  value: /^(?:(?:https?|ftp):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/,
                  message: "Invalid URL"
                },
              }}
              control={props.control}
              defaultValue=""
              render={({ field: { onBlur, onChange, value } }) => (
                <Input placeholder="https://www.quip.com/" value={value} onChange={({ detail }) => {
                  onChange(detail.value);
                }}
                  onBlur={onBlur} />
              )} />
          </FormField>
        </ColumnLayout>
        <ColumnLayout columns={2}>
          <FormField
            stretch={true}
            description="The name of the vendor of the appication, please use the suggestions from dropdown first"
            label="Name of the vendor" errorText={props.errors?.vendor_name?.message?.toString()}>
            <Controller
              name="vendor_name"
              rules={{
                required: "Required field",
                maxLength: {
                  value: 64,
                  message: "Maximum accepted length is 64"
                },
                pattern: {
                  value: /^[\w\-\s]+$/,
                  message: "Only alphanumeric accepted"
                }
              }}
              control={props.control}
              defaultValue=""
              render={({ field: { onBlur, onChange, value } }) => (
                <Input placeholder="Salesforce" value={value} onChange={({ detail }) => {
                  onChange(detail.value);
                }}
                  onBlur={onBlur} />
              )} />
          </FormField>
          <FormField
            stretch={true}
            description="Enter the full URL of the vendor's main website"
            label="Vendor's website" errorText={props.errors?.vendor_website?.message?.toString()}>
            <Controller
              name="vendor_website"
              rules={{
                required: "Required field",
                pattern: {
                  value: /^(?:(?:https?|ftp):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/,
                  message: "Invalid URL"
                },
              }}
              control={props.control}
              render={({ field: { onBlur, onChange, value } }) => (
                <Input placeholder="https://www.salesforce.com/" value={value} onChange={({ detail }) => {
                  onChange(detail.value);
                }}
                  onBlur={onBlur} />
              )} />
          </FormField>
        </ColumnLayout>
        <FormField label="How important is this system to your team or business unit">
          <Controller
            name="importance"
            rules={{ required: "Required field", }}
            control={props.control}
            defaultValue="medium"
            render={({ field: { onChange, value } }) => (
              <Tiles
                onChange={({ detail }) => { onChange(detail.value) }}
                value={value}
                items={[
                  { value: "low", label: "Low", description: "Not so important" },
                  { value: "medium", label: "Medium", description: "Somewhat important" },
                  { value: "high", label: "High", description: "Very important" },
                  { value: "critical", label: "Critical", description: "Absolutely necessary" }
                ]}
              />
            )} />
        </FormField>
      </SpaceBetween>
    </Container>
  );
}